import { gql } from "apollo-boost"

export const initializeFinancialStatementMonths = gql`
mutation InitializeFinancialStatementMonths($submissionId: String!) {
InitializeFinancialStatementMonths(submissionId: $submissionId) {
    id
    month
    }
  }
`